export default __webpack_public_path__ + "static/media/OSMOS_CALCE_C2_GRIP_120X120_02.4d11a6fe.jpg";